import React from 'react'

import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import queryString from 'query-string';
import Swal from 'sweetalert2'

import ReactLoading from 'react-loading';
import config from "../../config"

import { useNetworkState } from 'react-use';
import Footer from './Footer';
import Header from './Header';
const Rate_card = () => {
    const [products, setProducts] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    React.useEffect(() => {
        // Fetch product pricing data
        const fetchPricingData = async () => {
            try {
              setLoading(true);
              const full_api = `${config.apiUrl}/shipment/getPricingData`;
          
              const response = await axios.post(full_api, {}, { headers: config.headers });
          
              if (response.data?.success && Array.isArray(response.data.products)) {
                setProducts(response.data.products);
              } else {
                console.warn("No products found in API response:", response.data);
                setProducts([]);
              }
            } catch (error) {
              console.error("Error fetching product pricing:", error);
              setProducts([]);
            } finally {
              setLoading(false);
            }
          };
    
        fetchPricingData();
      }, []);
  return (
    <div>
      <Header/>
 <div class="page-wrapper pinned">
  <div class="main-container">
   <div className='app-container'>
  <div class="app-body">
  <div class="container-fluid"> 
  {products.length > 0 ? (
  products.map((product, productIndex) => (
    <div
      key={productIndex}
      className="p-4 mb-6 bg-white shadow-md rounded-xl border border-gray-200"
    >
      <h3 className="text-lg font-semibold mb-3 text-gray-800">
        {product.product_name}{" "}
        <span className="text-sm text-gray-500">({product.mode})</span>
      </h3>

      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse text-sm">
          <thead>
            <tr className="bg-gray-100 text-gray-700 text-left">
              <th className="p-3 border border-gray-300 sticky left-0 bg-gray-100">
                Weight Range (KG)
              </th>
              {product.zones.map((zone, idx) => (
                <th
                  key={idx}
                  className="p-3 border border-gray-300 text-center whitespace-nowrap"
                >
                  {zone.zone_name}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {product.groupedPricing.map((range, idx) => (
              <tr
                key={idx}
                className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                <td className="p-3 border border-gray-300 font-medium text-gray-700">
                  {range.start_range} - {range.end_range}
                </td>
                {product.zones.map((zone, zIdx) => {
                  const zonePrice = range.zone_prices.find(
                    (zp) => zp.zone_id === zone.zone_id
                  );
                  return (
                    <td
                      key={zIdx}
                      className="p-3 border border-gray-300 text-center"
                    >
                      {zonePrice ? zonePrice.price : "N/A"}
                    </td>
                  );
                })}
              </tr>
            ))}

            {/* Additional weight pricing row */}
            <tr className="bg-yellow-50 font-medium">
              <td className="p-3 border border-gray-300">
                Additional per {product.additional_weight} KG
              </td>
              {product.zones.map((zone, zIdx) => {
                const additionalPrice =
                  product.additionalPrices.find(
                    (ap) => ap.zone_id === zone.zone_id
                  )?.additional_price || "N/A";
                return (
                  <td
                    key={zIdx}
                    className="p-3 border border-gray-300 text-center"
                  >
                    {additionalPrice}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  ))
) : (
  <p className="text-gray-500 text-center py-4">
    No products available to display.
  </p>
)}

  </div>
  </div></div>
  <Footer/>
  </div></div> 
    </div>
  )
}

export default Rate_card
